<template>
    <div class="login">
        <div style="text-align: center;">
            <h3>Log Back In</h3>
            <p>Enter your email address below and we&rsquo;ll send you a login link.</p>
        </div>
        <div v-if="responseMessage" class="alert is-focus">{{ responseMessage }}</div>
        <form v-on:submit.prevent="login" id="form_start" method="POST" action="/login">
            <label for="login_email" class="is-hidden">Email</label>
            <input id="login_email" type="text" name="email" placeholder="Email Address">
            <button type="submit">Send Email</button>
        </form>
    </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

export default {
    name: 'LoginAgain',
    components: {
    },
    data: function() {
        return {
            responseMessage: ''
        }
    },
    methods: {
        login: function () {
            const form = document.getElementById('form_start');
            const formData = new FormData(form);
            const router = this.$router;
            const self = this;
            Axios.post('/login', formData).then(function (response) {
                self.responseMessage = response.data.message;
            });
        }
    }
}
</script>
